// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__14zW9","upload":"Small_upload__2jR14","imageWrap":"Small_imageWrap__3i6Dk","removeBtn":"Small_removeBtn__rpoqo"};